import updateCurrentSidebarAction from 'modules/sidebar/redux/actions/update-current'
import removeProductAndVariantIdFromUrlUtil from 'containers/QuickShopProductSidebar/utils/remove-product-and-variant-id-from-url'

export default function closeSidebarAction () {
  return (dispatch) => {
    removeProductAndVariantIdFromUrlUtil()
    dispatch(updateCurrentSidebarAction())
  }
}
